import $ from 'jquery';
import axios from 'axios';
import { validationForm } from '../_utilFreeform';
import Swal from 'sweetalert2';
const additem = document.querySelector('.FormCotizar-producto  .FormCotizar-producto-cantidad .btn-cantidad.sumar');
const removeitem = document.querySelector('.FormCotizar-producto  .FormCotizar-producto-cantidad .btn-cantidad.restar');
const cantidaditem = document.querySelector('.FormCotizar-producto  .FormCotizar-producto-cantidad .input-cantidad-cotizacion');
const formcotizar = document.querySelector('.FormCotizar-producto');
let isSubmitting = false;

if (formcotizar) {
  const fieldEmail = formcotizar.querySelector('input[name="email"]');
  const selpresentacion = formcotizar.querySelector('[name="presentacion"]');
  additem.addEventListener('click', (e) => {
    e.preventDefault();
    let actual = Number(cantidaditem.value);
    try {
      let next = actual + 1;
      cantidaditem.value = '' + next;
    } catch (e) {
      console.warn('Numero invalido', e);
    }
    if(selpresentacion){
      val_cantidadminima_presentacion();
    }
  });

  removeitem.addEventListener('click', (e) => {
    e.preventDefault();
    let actual = Number(cantidaditem.value);
    try {
      let next = actual - 1;
      if (next > 0) {
        cantidaditem.value = '' + next;
      } else {
        cantidaditem.value = '' + 1;
      }
    } catch (e) {
      console.warn('Numero invalido', e);
    }
    if(selpresentacion){
      val_cantidadminima_presentacion();
    }
  });
  var checkcte = document.getElementById('soycontycte');
  if (document.getElementById('soycontycte')) {
    checkcte.addEventListener('click', function () {
      if (checkcte.checked) {
        checkcte.value = 'Si';
      } else {
        checkcte.value = 'No';
      }
    });
  }
  var namecte = document.getElementById('fullNameCotizacion');
  var asuntocte = document.getElementById('Asuntocte-cot');
  if (namecte) {
    namecte.addEventListener('change', (e) => {
      asuntocte.value = `Cotización solicitada por  ${namecte.value} `;
    });
  }

  const deleteErros = async function (form) {
    try {
      let listErros = form.querySelectorAll('ul[data-error]');
      if (listErros.length > 0) {
        listErros.forEach((item) => item.remove());
      }
    } catch (Exception) {
      console.warn('Exception in deleteErros => ' + Exception);
    }
  };

  if (fieldEmail) {
    fieldEmail.addEventListener('blur', function () {
      const isValid = validationForm(fieldEmail);
     /* const submitButton = formcotizar.querySelector('button[type="submit"]');
      if (isValid && submitButton.disabled ) {
        submitButton.style.cursor = 'pointer';
        submitButton.style.backgroundColor = '#3dae2b'; 
        return (submitButton.disabled = false);
      }
      //return (submitButton.disabled = false); */
    });
  }


let reenableBtn = function () {
    document.querySelectorAll('button[type="submit"]').forEach(btn => {
      btn.removeAttribute('disabled');
        btn.style.backgroundColor = '#3dae2b'; 
        btn.style.pointerEvents = 'auto';
        btn.style.cursor = 'pointer';
    });
};


  formcotizar.addEventListener(
    'submit',
    async (event) => {
      try {
        event.preventDefault();
        if (isSubmitting) return; // 🚫 evita múltiples clics rápidos
        isSubmitting = true;
        let form = event.target;
        /*document.querySelectorAll('button[type="submit"]').forEach(btn => {
          btn.setAttribute('disabled',"true");
          btn.disabled = true;
          btn.style.backgroundColor = '#94c97e';
          btn.style.cursor = 'not-allowed';
        });*/
        const submitButton = formcotizar.querySelector('button[type="submit"]');
        submitButton.disabled=true;
        submitButton.style.backgroundColor="#94c97e";
        submitButton.style.cursor = 'not-allowed';
        
        if (fieldEmail && fieldEmail.value) {
          const isValid = validationForm(fieldEmail);
          if (!isValid){
            Swal.fire(
              'Ha ocurrido un error',
              'Verifica tu información. No se ha podido enviar el formulario.',
              'error'
            );
            isSubmitting = false;
            return reenableBtn();
          }
        }
        
        //validad cantidad minima requerida por presentación
        if(selpresentacion){
          let validarminimos = val_cantidadminima_presentacion();
          if(!validarminimos){
            Swal.fire(
              'Ha ocurrido un error',
              'Verifica tu información o inténtalo más tarde. No se ha podido enviar el formulario.',
              'error'
            );
            return;
          };
        }
        // ---------- Agregar valores por default ----------------------
        let notas_formulario = '';
        const tituloPipedrive = form.querySelector('[name="tituloPipedriveLead"]');
        const empresa = form.querySelector('[name="company"]');
        const Producto = form.querySelector('[name="productoDeInteres"]');
        const notes = form.querySelector('[name="notas"]');
        const asunto = form.querySelector('[name="asunto"]');
        const pedido_periodico = form.querySelector('[name="pedidoPeriodico"]');
        const presentacion_prod = form.querySelector('[name="presentacion"]');
        if(asunto){
          notas_formulario = ` ${notas_formulario} Asunto: ${asunto.value} \n`;
        }
        
        if(presentacion_prod != undefined && presentacion_prod.value != ""){
          if(Producto){
            notas_formulario = ` ${notas_formulario} Producto: ${Producto.value}, Pedido periódico: ${pedido_periodico.value}, Presentación: ${presentacion_prod.value} \n`;
          }
        }else{
          if(Producto){
            notas_formulario = ` ${notas_formulario} Producto: ${Producto.value}, Pedido periódico: ${pedido_periodico.value} \n`;
          }
        }
        if(tituloPipedrive){
          if(!tituloPipedrive.value.includes(empresa.value)){
            tituloPipedrive.value = `[${tituloPipedrive.value}] [${empresa.value ?? ''}]`;
          }
        }
        if(notes){
          notes.value=notas_formulario;
        }
        /// ----------------------------
        let action = form.querySelector("input[name='action']");
        let response = await axios({
          url: action.value,
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            HTTP_X_REQUESTED_WITH: 'XMLHttpRequest'
          },
          data: new FormData(form)
        });
        let { success, errors, honeypot } = response.data;
        //console.log("response ", response);
        await deleteErros(form);
        if (!success) {
          //reenableBtn();
          let { dataset } = form;
          let honeypotInput = form.querySelector(`[name="${dataset.honeypotName}"]`);
          if (honeypotInput) {
            honeypotInput.name = honeypot.name;
            honeypotInput.value = honeypot.hash;
            honeypotInput.id = honeypot.name;
            dataset.honeypotName = honeypot.name;
            dataset.honeypotValue = honeypot.hash;
          }

          for (let error in errors) {
            let errorElement = document.createElement('ul');
            errorElement.setAttribute('data-error', true);
            errorElement.style.color = 'red';
            errorElement.style.margin = '0px';
            errorElement.style.width = '100%';
            errorElement.style.fontSize = 'small';
            errorElement.classList.add('py-2');
            let field = form.querySelector(`[name="${error}"]`);
            if (field) {
              let stringError = '';
              errors[error].forEach((item) => {
                stringError += ` <li>${item}</li> `;
              });
              errorElement.innerHTML = stringError;
              field.insertAdjacentElement('afterend', errorElement);
            }
          }
          tituloPipedrive.value="Cotizar Producto";
          isSubmitting = false;
          return reenableBtn();
        }
        form.reset();
        isSubmitting = false;
        tituloPipedrive.value="Cotizar Producto";
        try {
            //reenableBtn();
          Swal.fire('Formulario enviado!', 'El formulario fue enviado con éxito, pronto nos pondremos en contacto contigo.', 'success');
          let producto = form.querySelector("input[name='productoDeInteres']").value ?? '';
          gtag('event', 'cotizador', {
            event_category: 'cotizar producto',
            event_label: '' + producto.value
          });
        } catch (Exception) {
          console.warn('Exception in gtag => ' + Exception);
        }
        return reenableBtn();
        //return window.location.reload();
      } catch (Exception) {
        isSubmitting = false;
        eenableBtn();
        console.warn('Exception in submitForms => ' + Exception);
      }
    },
    false
  );
  if(selpresentacion){
    selpresentacion.addEventListener("change", e=>{
      // se cambio la presentación
      const sel = e.currentTarget;
      const selectedOption = sel.selectedOptions[0]; 
      const minValue = selectedOption.dataset.min;
      //ajustamos que el valor de cantidad sea igual al minimo requerido y definimos el min value
      //cantidaditem.value=minValue;
      if(minValue){
        cantidaditem.min=minValue;
      }else{
        cantidaditem.min=1;
      }
    })
  }
  
  cantidaditem.addEventListener("change", e=>{
    if(selpresentacion){
      val_cantidadminima_presentacion();
    }
    if(e.currentTarget.value < 1){
      e.currentTarget.value = 1;
    }
  });
  function val_cantidadminima_presentacion() {
    //Obtenemos la presentacion actual seleccionada y el valor de la cantidad
    let currentValue = Number(cantidaditem.value);
    const selectedOption = selpresentacion.selectedOptions[0]; 
    const minValue = Number(selectedOption.dataset.min);
    reenableBtn();
    if(minValue){
      if(currentValue < minValue){
        seterror_validation_cantidad(cantidaditem,`El valor mínimo permitido es ${minValue} `);
        return false;
      }else{
        remove_error_cantidad(); 
        return true;
      }
    }
  }
}

const remove_error_cantidad = ()=>{
  let alert = document.getElementById("min-error");
  if(alert){
    alert.remove();
  }
}
const seterror_validation_cantidad = function (field, message) {
  if (!field) return false;
  const parent = field.parentElement.parentElement.parentElement;
  remove_error_cantidad();
  const newElement = document.createElement('p');
  newElement.classList.add('my-2', 'px-2');
  newElement.setAttribute('style', 'color:red');
  newElement.setAttribute('id', 'min-error');
  newElement.textContent = message;
  parent.appendChild(newElement);
};